import { render, staticRenderFns } from "./ReportImageRegistration.vue?vue&type=template&id=2f47da67&"
import script from "./ReportImageRegistration.vue?vue&type=script&lang=ts&"
export * from "./ReportImageRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports